// extracted by mini-css-extract-plugin
export default {"content":"LessonResumeWidget_content__4AbkX","btn":"LessonResumeWidget_btn__saIJA"};